export class CoordinationRequest{    
    public coordinationName: string;
}